export const ACTION_VIEW = ['goToClone', 'cloneYaml', 'goToViewYaml', 'goToViewConfig', 'promptRemove'];
